import { render, staticRenderFns } from "./SensorDetailTable.vue?vue&type=template&id=ff410a38&"
import script from "./SensorDetailTable.vue?vue&type=script&lang=js&"
export * from "./SensorDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports